<script setup>
import Underline from "@tiptap/extension-underline";
import Youtube from "@tiptap/extension-youtube";
import { generateHTML } from "@tiptap/html";
import StarterKit from "@tiptap/starter-kit";
import { computed } from "vue";
const props = defineProps({
  field: { type: Object, required: true }
});
const output = computed(() => {
  if (!props.field.value)
    return null;
  if (props.field.value && typeof props.field.value === "object")
    return generateHTML(props.field.value, [StarterKit, Underline, Youtube]);
  return props.field.value;
});
</script>

<template>
  <div v-if="field.enabled && output" class="voix-wysiwyg">
    <div v-html="output" />
  </div>
</template>
